var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section main-section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("title-comp", {
          attrs: {
            name: _vm.$t("alert.promo_code_is_correct", {
              code: _vm.userPromoCode,
            }),
          },
        }),
        _c("div", { staticClass: "form-container form-login" }, [
          _c("div", { staticClass: "split-container" }, [
            _c(
              "p",
              {
                staticClass: "subtitle has-text-centered no-line-break-mobile",
                staticStyle: { "margin-bottom": "1rem" },
              },
              [_vm._v(_vm._s(_vm.$t("profile.promo_code_access1")))]
            ),
            _c("div", { staticClass: "has-text-centered" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary button-access",
                  attrs: { type: "button" },
                  on: { click: _vm.goSignup },
                },
                [_vm._v(_vm._s(_vm.$t("menu.signup")))]
              ),
            ]),
          ]),
          _c("div", { staticClass: "split-container margin-top-md" }, [
            _c("p", { staticClass: "subtitle has-text-centered" }, [
              _vm._v(_vm._s(_vm.$t("profile.promo_code_access_login1") + " ")),
              _c(
                "a",
                {
                  staticStyle: { "text-decoration": "underline" },
                  on: { click: _vm.goLogin },
                },
                [_vm._v(_vm._s(_vm.$t("button.access_here")))]
              ),
              _vm._v(_vm._s(" " + _vm.$t("profile.promo_code_access_login2"))),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }